<template>

  <v-container fluid grid-list-sm pa-0 ma-0 v-resize="onResize">

<v-expansion-panels v-model="panel" >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-layout>
        <v-flex xs4>
          <div >{{partyName || 'No Name' }}</div>
        </v-flex>
        <v-flex xs4>
          Date: {{formatDate || 'Set Date'}}
        </v-flex>
        <v-flex xs4>
          {{tax_disp || 'tax'}}
        </v-flex>
      </v-layout>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
      <v-layout row>
          <v-flex xs12 md4>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="formatDate"
              label="Date (read only text field)"
              hint="MM/DD/YYYY format"
              persistent-hint
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
        <p>Date in ISO format: <strong>{{ date }} // {{formatDate}}</strong></p>
      </v-flex>
          <v-flex xs6 md4 >
            <v-switch
            label="Tax Inclusive"
            v-model="tax_inc"
            ></v-switch>
          </v-flex>
          <v-flex xs6 md4>
            <v-select
            :items="stCode"
            v-model="stSelect"
            item-text="state"
            label="Select"
            return-object
            >
            </v-select>
          </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-text-field
            label="Phone No."
            type="tel"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-autocomplete
            label="Book Series"
            :items="series"
            item-text="txt"
    ></v-autocomplete>
        </v-flex>
      </v-layout> 
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-autocomplete
              v-model="partyName"
              :items="partyList"
              item-text="name"
              label= "select Party"
              single-line
              return-object
              ref="0"
              v-on:keydown.enter="gonext('1')"
              >
        <template slot="no-data">
          <v-btn @click.stop="partyDialog=true" color=success>add new Party</v-btn>
        </template>
      </v-autocomplete>
          </v-flex>

            <v-flex xs12 sm6>
              <v-text-field
              label="Address :"
              v-model="address"
              ></v-text-field>
            </v-flex>

          </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>    
    
<my-party-form />
</v-container>
</template>

<script>
export default {
data () {
  return {
    panel: 0,
    bp:0,
    menu1: false
    //date: null,

  }
},
components: {
'my-party-form': () =>import('@/components/partyForm.vue')
},
computed: {
    series() {
      return this.$store.getters['bookseries/series']
    },
    formatDate() {
      return this.$store.getters['invoice/formatDate']
    },
    tax_inc: {
      get() {
        return this.$store.state.invoice.tax_inc
      },
      set(value){
        this.$store.dispatch('invoice/tax_inc',value)
      }
    },
    partyDialog: {
      get() {
        return this.$store.state.partyDialog
      },
      set(value) {
        this.$store.dispatch('partyDialog')
      }
    },
    tax_disp(){
      if (this.$store.state.invoice.tax_inc ==true ) {
        return 'Tax Inclusive'
      } else {
        return 'Tax Extra'
      }

    },
    partyName: {
      get() {
        return this.$store.state.invoice.c_name
      },
      set(value){
        this.$store.dispatch('invoice/partyName',value)
      }
    },
    partyList() {
      return this.$store.state.invoice.partyList
    },
    stCode() {
      return this.$store.state.invoice.st_code
    },
    stSelect: {
      get() {
        return this.$store.state.invoice.st_select
      },
      set(value) {
        this.$store.dispatch('invoice/stSelect',value)
      }
    },
    address: {
      get(){
        return this.$store.state.invoice.address
      },
      set(value) {
        this.$store.dispatch('invoice/address', value)
      }
    },
    date: {
      set(date) {
        this.menu1= false
        this.$store.dispatch('invoice/setDate', date)
      },
      get() {
        return this.$store.state.invoice.date
      }
    }
},
methods: {
  setdate() {
    this.menu1= false
    //this.$store.state.date = this.date
    this.$store.dispatch('invoice/setDate', this.date)
  },
  onResize () {
    if( this.$vuetify.breakpoint.name != this.bp && this.$vuetify.breakpoint.name=="xs" ) {
      this.bp=this.$vuetify.breakpoint.name
      return this.panel=1
    } else {
     if(this.$vuetify.breakpoint.smAndUp== true) {
       this.bp=this.$vuetify.breakpoint.name
       return this.panel=0
     }

    }
    
  }
},
mounted () {
    this.$store.dispatch('bookseries/fetchSeries')
    this.$store.dispatch('party/fetchParty')
    this.bp = this.$vuetify.breakpoint.name
    this.onResize()
    
},
created () {
  this.$store.dispatch('invoice/fetchParty',false)
}
}
</script>
